<template>
  <v-container grid-list-xs class="pa-0">
    <v-layout row wrap>
      <v-flex xs12 md6 class="text-xs-center offset-md3">
        <v-card class="elevation-4">
          <v-card-title class="info white--text">
            <h2 v-if="user.premium" class="headline">Update Payment Method</h2>
            <h2 v-if="!user.premium" class="headline">
              Go Premium for Only $9.99 Per Year
            </h2>
          </v-card-title>
          <v-card-title class="info white--text text-xs-left pt-0 pb-0">
            <p v-if="!user.premium" class="font-weight-bold pr-1">
              14 day risk free trial!
            </p>
            <p v-if="!user.premium">
              Cancel for any reason and receive a full refund during this time
              period.
            </p>
            <p v-if="!user.premium">
              Enjoy an ad-free experience, record your test history, and log
              your chemical history for up to 5 pools!
            </p>
            <p v-if="user.premium">
              Notice: If at any point you would like to cancel your premium
              membership please contact
              <a href="mailto:support@poolcalculator.com" class="white--text"
                >support@poolcalculator.com.</a
              >
              Should you choose to do so, your membership will remain active
              through the end of your current billing year but not renew next
              year.
            </p>
          </v-card-title>
          <v-form class="mb-3 pa-3" @submit="submitUpdate">
            <v-layout row wrap>
              <v-flex class="pl-1 xs12">
                <div ref="cardArea" />
              </v-flex>
              <v-flex class="mt-2">
                <v-btn block round color="info" class="mt-3" type="submit">
                  <div class="loader" v-if="loading"></div>
                  <span v-else
                    ><v-icon class="mr-2">mdi-lock-outline</v-icon
                    >{{ user.premium ? "Update" : "Register" }}</span
                  >
                </v-btn>
              </v-flex>
            </v-layout>
            <v-flex v-if="$route.query.fromRegistration">
              <router-link to="/settings/pools"
                >Not right now. I want to set up my pool.</router-link
              >
            </v-flex>
          </v-form>
        </v-card>
      </v-flex>
      <v-snackbar v-model="snackbar.show" :bottom="true" :right="true">
        {{ snackbar.message }}
        <v-btn color="red" flat @click="snackbar.show = false">Close</v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      fields1: [
        {
          name: "First Name",
          type: "text",
          value: "",
          classes: ["pl1", "xs12"],
        },
        {
          name: "Last Name",
          type: "text",
          value: "",
          classes: ["pl1", "xs12"],
        },
        {
          name: "Email",
          type: "email",
          value: "",
          classes: ["pl1", "xs12"],
        },
      ],
      fields2: [
        {
          name: "Type",
          type: "select",
          value: "",
          items: ["Pool Owner", "Pool Professional"],
          classes: ["pl1", "xs12"],
        },
        {
          name: "Password",
          type: "password",
          value: "",
          classes: ["pl1", "xs12"],
        },
        {
          name: "Confirm Password",
          type: "password",
          value: "",
          classes: ["pl1", "xs12"],
        },
      ],
      snackbar: {
        show: false,
        message: "",
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
  },
  methods: {
    ...mapActions({
      initUser: "user/initUser",
      saveUser: "user/saveUser",
      register: "user/register",
    }),
    async cancel() {
      await this.saveUser({
        premium: false,
      });
      this.snackbar.show = true;
      this.snackbar.message = "Your premium membership has been cancelled";
    },
    async submitUpdate(evt) {
      evt.preventDefault();
      this.loading = true;
      try {
        await this.save();
      } catch (err) {
        this.snackbar = { show: true, message: err.message };
      }
      this.loading = false;
    },
    async save() {
      const wasPremium = this.user.premium;
      const response = await stripe.createToken(this.cardElement);
      if (response.error) {
        throw new Error("Error: " + response.error.message);
      }
      console.log(response);
      const token = response.token.id;
      await this.saveUser({
        premium: true,
        card: token,
      });
      this.snackbar.show = true;
      this.snackbar.message =
        "Your payment method has been updated successfully";
      console.log("billing ran");

      if (!wasPremium) {
        this.$router.push({ name: "account.billing.nowPremium" });
      }
    },
  },
  async mounted() {
    console.log("mounted billing");
    const userQuery = this.initUser();

    this.stripeElements = stripe.elements(stripeElementsConfig);

    const stripeElementStyle = {
      base: { fontSize: "16px", fontFamily: "Roboto, sans-serif" },
    };

    this.cardElement = this.stripeElements.create("card", {
      style: stripeElementStyle,
    });
    this.cardElement.mount(this.$refs.cardArea);

    await userQuery;

    this.cardElement.update({ value: { postalCode: this.user.postalCode } });
  },
  async beforeDestroy() {
    console.log("destroying billing");
    this.cardElement.destroy();
  },
};
</script>

<style lang="scss" scoped>
.border-right {
  border-right: 1px solid #d8d8d8;
}
.StripeElement {
  margin-top: 4px;
  padding-top: 12px + 7px;
  padding-bottom: 7px;
  margin-bottom: 12px;
  position: relative;

  &::before,
  &::after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: thin solid rgba(0, 0, 0, 0.42);
    height: 0;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  }

  &::after {
    border-color: #1976d2;
    transform: scaleX(0);
    border-top-width: 2px;
  }

  &:hover::before {
    border-color: rgba(0, 0, 0, 0.87);
  }

  &.StripeElement--focus::after {
    transform: scaleX(1);
  }
}
</style>
